import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar, Menu } from "react-pro-sidebar";
import { FiMenu } from "react-icons/fi";
import { FaDiscord } from "react-icons/fa";

import { MenuItem } from "../MenuItem/MenuItem";
import { SubMenuComponent } from "../SubmenuComponent/SubmenuComponent";
import { submenus } from "../../routes/submenus";

import {
  Header,
  SidebarContainer,
  StyledMenuItem,
  ToggleContainer,
  HeaderContent,
  DiscordButtonWrapper,
} from "./styles";

import appIcon from "../../assets/images/app-icon-no-bg-small.png";
import Button from "components/atoms/Button/Button";
import { createIcon } from "utils/iconUtils";

interface MySidebarProps {
  isMobileSidebarOpen?: boolean;
  onClose?: () => void;
}

const MenuIcon = createIcon<{ size?: number }>(FiMenu);
const DiscordIcon = createIcon<{ size?: number }>(FaDiscord);

export const MySidebar: React.FC<MySidebarProps> = ({
  isMobileSidebarOpen = true,
  onClose,
}) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [selected, setSelected] = useState<string>("Dashboard");
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath.startsWith("/configuration/edit/") ||
      currentPath.startsWith("/profile")
    ) {
      setSelected("");
      setOpenSubMenu(null);
    }
  }, [location]);

  const toggleSubMenu = (menu: string) => {
    setOpenSubMenu(openSubMenu === menu ? null : menu);
  };

  // Update selected item based on current location
  useEffect(() => {
    const currentPath = location.pathname;
    let foundSelected: string | undefined;
    let foundParent: string | undefined;

    submenus.forEach((submenu) => {
      if (submenu.to === currentPath) {
        foundSelected = submenu.title;
      }

      if (submenu.subRoutes) {
        submenu.subRoutes.forEach((subRoute) => {
          if (subRoute.to === currentPath) {
            foundSelected = subRoute.title;
            foundParent = submenu.title;
          }
        });
      }
    });

    if (foundSelected) {
      setSelected(foundSelected);
      if (foundParent) {
        setOpenSubMenu(foundParent);
      } else {
        setOpenSubMenu(null);
      }
    }
  }, [location]);

  return (
    <SidebarContainer $isMobileOpen={isMobileSidebarOpen}>
      <Sidebar collapsed={isCollapsed}>
        <Menu>
          <StyledMenuItem>
            <HeaderContent $isCollapsed={isCollapsed}>
              {!isCollapsed && (
                <Header>
                  <img src={appIcon} width={70} height={70}></img>
                  <span>ACF Automation</span>
                </Header>
              )}
              <ToggleContainer
                onClick={() => {
                  if (isMobileSidebarOpen) {
                    setIsCollapsed(false);
                    onClose && onClose();
                  } else setIsCollapsed(!isCollapsed);
                }}
              >
                <MenuIcon />
              </ToggleContainer>
            </HeaderContent>
          </StyledMenuItem>

          {submenus.map((route) =>
            route.subRoutes ? (
              <SubMenuComponent
                key={route.title}
                title={route.title}
                icon={route.icon}
                open={openSubMenu === route.title}
                toggleSubMenu={() => toggleSubMenu(route.title)}
                selected={selected}
                setSelected={setSelected}
                isCollapsed={isCollapsed}
              >
                {route.subRoutes.map((subRoute) => (
                  <MenuItem
                    key={subRoute.title}
                    title={subRoute.title}
                    to={subRoute.to!}
                    icon={!isCollapsed ? subRoute.icon : <></>}
                    selected={selected}
                    setSelected={setSelected}
                    onClose={onClose}
                  />
                ))}
              </SubMenuComponent>
            ) : (
              <MenuItem
                key={route.title}
                title={route.title}
                to={route.to!}
                icon={route.icon}
                selected={selected}
                setSelected={setSelected}
                onClose={onClose}
              />
            )
          )}
        </Menu>
      </Sidebar>
      <DiscordButtonWrapper $isCollapsed={isCollapsed}>
        <Button
          onClick={() => window.open("https://discord.gg/gcxP4QKf2z", "_blank")}
          icon={<DiscordIcon />}
          variant="discord"
        >
          {!isCollapsed && "Join Our Discord"}
        </Button>
      </DiscordButtonWrapper>
    </SidebarContainer>
  );
};
